import OpenDoor from '@propertypal/shared/src/resources/icons/contact/open-door.svg?url';
import platform from '@propertypal/shared/src/utils/platform';
import React from 'react';
import { Box } from '../../layout';
import { Heading, Text } from '../../typography';
import { Container, HeaderContainer, HeaderIcon } from './ContactHeader.style.pn';

const ContactHeader = () => {
  return (
    <Container data-testid="contact-header">
      <HeaderContainer>
        <HeaderIcon src={OpenDoor.src} alt="PropertyNews Contact Us" />
        <Heading mt={25}>Contact Propertynews</Heading>
        <Box mt={10}>
          <Text fontSize={17}>At {platform.domain}, we are here to help with any questions you might have.</Text>
          <Text fontSize={17}>
            Please choose the option below that best describes your needs and we&apos;ll point you in the right
            direction.
          </Text>
        </Box>
      </HeaderContainer>
    </Container>
  );
};

export default ContactHeader;
